import { useEffect, useMemo } from 'react';
import uuid from 'uuid';

const useStyleString = (style: string): string => {
  const element = useMemo(() => document.createElement('style'), []);
  const classname = useMemo(() => `uss-${uuid()}`, []);

  useEffect(() => {
    element.innerText = `.${classname}{${style}}`;
  }, [style, element, classname]);

  useEffect(() => {
    document.head.appendChild(element);

    return () => {
      document.head.removeChild(element);
    };
  }, [element]);

  return classname;
};

export default useStyleString;
